export class Settings {
  relativeFontSize!: number;
  isGreyscale: boolean | undefined;
  arrowOption: string | undefined;
  isHighlightLinks: boolean | undefined;
  backgroundColorOption!: string;
}
